import { createFileRoute } from '@tanstack/react-router'
import { TrainersCreatePage } from '@/features/trainers'

export const Route = createFileRoute('/_authenticated/trainers/new')({
  component: TrainersCreatePage,
})
